import { render, staticRenderFns } from "./RunsList.vue?vue&type=template&id=4b607654"
import script from "./RunsList.vue?vue&type=script&lang=js"
export * from "./RunsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports